import { css } from "@emotion/react";
import { fontColor, FONTS, fontSize, fontStyles } from "../../../../styles/fonts";
import { CSS_MQ } from "../../../../styles/breakpoints";
import { CSS_COLORS } from "../../../../styles/styles-css-variables";
import React from "react";

export const ProductAttributeHeadline: React.FC<React.PropsWithChildren<{
  disabled?: boolean;
  headline: string;
}>> = props => {
  return (
    <div
      className={"u-d-flex u-ai-end"}
      css={css`
        --mb: 8px;
        ${CSS_MQ.atLeastSm} {
          --mb: 12px;
        }
        ${CSS_MQ.atLeastMd} {
          --mb: 16px;
        }

        margin-bottom: var(--mb);
      `}
    >
      <span css={[FONTS.SwarovskiFutura300, headlineStyles]} className={props.disabled ? "disabled" : undefined}>
        {props.headline}
      </span>

      <span
        css={css`
          margin-left: 9px;
          margin-bottom: 1px;
          ${FONTS.SwarovskiFutura300}
        `}
      >
        {props.children}
      </span>
    </div>
  );
};

const headlineStyles = [
  fontColor.black,
  fontSize.x2,
  css`
    text-transform: uppercase;

    display: block;

    &.disabled {
      color: ${CSS_COLORS.Grey2};
    }
  `,
];
